<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Customer Request Details</h4>
</div>
<div class="modal-body">
    <form>
        <fieldset>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label>First Name</label>
                    <input class="mvd_form-control" [value]="customerRequest.firstName" type="text" disabled />
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Middle Name</label>
                    <input class="mvd_form-control" [value]="customerRequest.middleName" type="text" disabled />
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Last Name</label>
                    <input class="mvd_form-control" [value]="customerRequest.lastName" type="text" disabled />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label>Date of Birth</label>
                    <input class="mvd_form-control" [value]="customerRequest.dateOfBirth | shortDate" type="text" disabled />
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Social Security Number</label>
                    <input class="mvd_form-control" [value]="customerRequest.ssn" type="text" disabled />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-9 mvd_form-group">
                    <label>Address</label>
                    <input class="mvd_form-control" [value]="customerRequest.addressLine1" type="text" disabled />
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Apartment, Suite</label>
                    <input class="mvd_form-control" [value]="customerRequest.addressLine2" type="text" disabled />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-7 mvd_form-group">
                    <label>City</label>
                    <input class="mvd_form-control" [value]="customerRequest.city" type="text" disabled />
                </div>
                <div class="col-sm-2 mvd_form-group">
                    <label>State</label>
                    <input class="mvd_form-control" [value]="customerRequest.jurisdictionDisplayValue" type="text" disabled />
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Zip Code</label>
                    <input class="mvd_form-control" [value]="customerRequest.postalZipCode" type="text" disabled />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-2 mvd_form-group">
                    <label>Country</label>
                    <input class="mvd_form-control" type="text" [value]="customerRequest.countryDisplayValue" disabled />
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Phone Number</label>
                    <input class="mvd_form-control" type="text" [value]="customerRequest.phoneNumber" disabled />
                </div>
                <div class="col-sm-7 mvd_form-group">
                    <label>Email Address</label>
                    <input class="mvd_form-control" type="text" [value]="customerRequest.emailAddress" disabled />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <label>Comments</label>
                    <textarea class="mvd_form-control" rows="10" disabled [value]="customerRequest.comment" ></textarea>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
    </div>
</div>